<template>
  <div>
    <div style="width: 64px;"></div>
    <el-menu :default-active="defaultActive" :router="routerSet" class="el-menu-vertical-demo left-menu" @open="handleOpen" @close="handleClose" :collapse="isCollapseInfo" >
      <el-menu-item :index="'/portal/account/MyTrip?source=' + source" v-if="allPermissions.module && (allPermissions.module.includes(2) || allPermissions.module.includes(6))">
        <div @mouseover="isMyBookingMouseOver = true" @mouseout="isMyBookingActive === false ? isMyBookingMouseOver = false : isMyBookingMouseOver = true">
          <el-tooltip content="Order Management" placement="top-start">
            <img style="padding-left: 2px;" :src="isMyBookingMouseOver ? hoverMyBookingImage : normalMyBookingImage" @mouseover="isMyBookingActive === false ? isMyBookingMouseOver = false : isMyBookingMouseOver = true" @mouseout="isMyBookingMouseOver = false">
          </el-tooltip>
          <span style="margin-left:15px;" :class="{'blue-text': isMyBookingActive === true}">My Bookings</span>
        </div>
      </el-menu-item>
      <el-menu-item :index="'/portal/booking/hotelsearch/HotelList?source=' + source" v-if="allPermissions.module && (allPermissions.module.includes(1) || allPermissions.module.includes(5))">
        <div @mouseover="isBookMouseOver = true" @mouseout="isBookActive === false ? isBookMouseOver = false : isBookMouseOver = true">
          <el-tooltip content="Booking" placement="top-start">
            <img style="padding-left: 2px;" :src="isBookMouseOver ? hoverBookImage : normalBookImage" @mouseover="isBookMouseOver = true" @mouseout="isBookActive === false ? isBookMouseOver = false : isBookMouseOver = true">
          </el-tooltip>
          <span style="margin-left:15px;" :class="{'blue-text': isBookActive === true}">Booking</span>
        </div>
      </el-menu-item>
      <el-menu-item :index="'/portal/dashboard?source=' + source" v-if="allPermissions.module && allPermissions.module.includes(4)">
        <div @mouseover="isDataMouseOver = true" @mouseout="isDataActive === false ? isDataMouseOver = false : isDataMouseOver = true">
          <el-tooltip content="Dashboard" placement="top-start">
            <img style="padding-left: 2px;" :src="isDataMouseOver ? hoverDataImage : normalDataImage" @mouseover="isDataMouseOver = true" @mouseout="isDataActive === false ? isDataMouseOver = false : isDataMouseOver = true">
          </el-tooltip>
          <span style="margin-left:15px;" :class="{'blue-text': isDataActive === true}">Dashboard</span>
        </div>
      </el-menu-item>
      <el-menu-item :index="'/portal/account/myAccount?source=' + source" v-if="allPermissions.module && allPermissions.module.includes(3)">
        <div @mouseover="isAccountMouseOver = true" @mouseout="isAccountActive === false ? isAccountMouseOver = false : isAccountMouseOver = true">
          <el-tooltip content="My Account" placement="top-start">
            <img style="padding-left: 2px;" :src="isAccountMouseOver ? hoverAccountImage : normalAccountImage" @mouseover="isAccountMouseOver = true" @mouseout="isAccountActive === false ? isAccountMouseOver = false : isAccountMouseOver = true">
          </el-tooltip>
          <span style="margin-left:15px;" :class="{'blue-text': isAccountActive === true}">My Account</span>
        </div>
      </el-menu-item>
      <el-menu-item :index="'/portal/account/myCoupon?source=' + source">
        <div @mouseover="isCouponMouseOver = true" @mouseout="isCouponActive === false ? isCouponMouseOver = false : isCouponMouseOver = true">
          <el-tooltip content="My Coupon" placement="top-start">
            <img style="padding-left: 2px;" :src="isCouponMouseOver ? hoverCouponImage : normalCouponImage" @mouseover="isCouponMouseOver = true" @mouseout="isCouponActive === false ? isCouponMouseOver = false : isCouponMouseOver = true">
          </el-tooltip>
          <span style="margin-left:15px;" :class="{'blue-text': isCouponActive === true}">Booking</span>
        </div>
      </el-menu-item>
      <el-menu-item class="left-menu-oalink" v-if="oaLinkShow">
        <div @click="skipOaLink">
          <img src="/static/img/inspect.png" style="width: 18px;height: 18px;">
        </div>
      </el-menu-item>
      <el-menu-item class="left-menu-email" v-if="allPermissions.email !== ''">
        <div>
          <el-tooltip class="item cancel-title-data-cont" effect="dark" :content="allPermissions.email" placement="top-start">
          <img style="padding-left: 2px;" src="/static/img/menu-email.svg">
          </el-tooltip>
        </div>
      </el-menu-item>
      <el-menu-item class="left-menu-phone" v-if="allPermissions.phone_internal !== '' || allPermissions.phone_external !== ''">
          <div>
            <el-tooltip class="item cancel-title-data-cont" effect="dark" placement="top-start">
              <template #content>
                <div class="tooltip-content">
                  <span v-if="allPermissions.phone_internal !== ''">{{allPermissions.phone_internal}}<br/></span>
                  <span v-if="allPermissions.phone_external !== ''">{{allPermissions.phone_external}}</span>
                </div>
              </template>
            <img style="padding-left: 2px;" src="/static/img/menu-tel.svg">
            </el-tooltip>
          </div>
      </el-menu-item>
    </el-menu>
  </div>
</template>
<script>
export default {
  name: 'publicMenu',
  props: ['isCollapse', 'allPermissions'],
  data () {
    return {
      defaultActive: '',
      normalDataImage: '/static/img/black_data.svg',
      hoverDataImage: '/static/img/blue_data.svg',
      isDataMouseOver: false,
      isDataActive: false,
      normalMyBookingImage: '/static/img/black_mybooking.svg',
      hoverMyBookingImage: '/static/img/blue_mybooking.svg',
      isMyBookingMouseOver: false,
      isMyBookingActive: false,
      normalBookImage: '/static/img/black_book.svg',
      hoverBookImage: '/static/img/blue_book.svg',
      isBookMouseOver: false,
      isBookActive: false,
      normalAccountImage: '/static/img/black_account.svg',
      hoverAccountImage: '/static/img/blue_account.svg',
      isAccountMouseOver: false,
      isAccountActive: false,
      isCollapseInfo: this.common.collapseSet(),
      routerSet: true,
      source: this.common.sourceSet(),
      oaLinkShow: false,
      isCouponMouseOver: false,
      isCouponActive: false,
      normalCouponImage: '/static/img/black_coupon.png',
      hoverCouponImage: '/static/img/blue_coupon.png'
      // emailHeight: document.documentElement.clientHeight - 200,
      // telHeight: document.documentElement.clientHeight - 120
    }
  },
  mounted: function () {
    var path = this.$route.path
    if (path.indexOf('HotelList') !== -1) {
      this.isBookMouseOver = true
      this.isDataMouseOver = false
      this.isMyBookingMouseOver = false
      this.isAccountMouseOver = false
      this.isCouponMouseOver = false

      this.isMyBookingActive = false
      this.isDataActive = false
      this.isBookActive = true
      this.isAccountActive = false
      this.isCouponActive = false
      this.defaultActive = '/portal/booking/hotelsearch/HotelList'
    } else if (path.indexOf('MyTrip') !== -1) {
      this.isBookMouseOver = false
      this.isDataMouseOver = false
      this.isMyBookingMouseOver = true
      this.isAccountMouseOver = false
      this.isCouponMouseOver = false

      this.isMyBookingActive = true
      this.isDataActive = false
      this.isBookActive = false
      this.isAccountActive = false
      this.isCouponActive = false
      this.defaultActive = '/portal/account/MyTrip'
    } else if (path.indexOf('myAccount') !== -1) {
      this.isBookMouseOver = false
      this.isDataMouseOver = false
      this.isMyBookingMouseOver = false
      this.isAccountMouseOver = true
      this.isCouponMouseOver = false

      this.isMyBookingActive = false
      this.isDataActive = false
      this.isBookActive = false
      this.isAccountActive = true
      this.isCouponActive = false
      this.defaultActive = '/portal/account/myAccount'
    } else if (path.indexOf('dashboard') !== -1) {
      this.isBookMouseOver = false
      this.isDataMouseOver = true
      this.isMyBookingMouseOver = false
      this.isAccountMouseOver = false
      this.isCouponMouseOver = false

      this.isMyBookingActive = false
      this.isBookActive = false
      this.isAccountActive = false
      this.isDataActive = true
      this.isCouponActive = false
      this.defaultActive = '/portal/dashboard'
    } else if (path.indexOf('Coupon') !== -1) {
      this.isBookMouseOver = false
      this.isDataMouseOver = false
      this.isMyBookingMouseOver = false
      this.isAccountMouseOver = false
      this.isCouponMouseOver = true

      this.isMyBookingActive = false
      this.isBookActive = false
      this.isAccountActive = false
      this.isDataActive = false
      this.isCouponActive = true
      this.defaultActive = '/portal/account/myCoupon'
    }
    this.source = this.common.sourceSet()
    var source = this.common.sourceSet()
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      source = this.$route.query.source
      var sourceExpires = localStorage.getItem('sourceExpiresAt')
      if (sourceExpires !== '' && sourceExpires !== undefined && sourceExpires !== null) {
        var nowTime = Date.now()
        if (nowTime > sourceExpires) {
          localStorage.removeItem('source')
          localStorage.removeItem('sourceExpiresAt')
        } else {
          // 避免手动干预删除或者修改localStorage
          if (source === '' || source === undefined || source === null) {
            localStorage.removeItem('source')
            localStorage.removeItem('sourceExpiresAt')
          } else {
            this.source = source
            this.common.sourceSet(source)
          }
        }
      }
    }
    if (this.source === '' || this.source === undefined || this.source === null) {
      let locationHref = window.document.location.href
      localStorage.setItem('LoginWebsiteAddress', locationHref)
      this.$router.push({name: 'login'})
    }
    // 底部链接跳转
    this.oaLinkShow = localStorage.getItem('oaLinkShow')
  },
  watch: {
    isCollapse: function (s, n) {
      this.isCollapseInfo = s
    }
  },
  methods: {
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    accountClick: function (type) {
      // 点击埋点 埋点记录
      this.clickPageAction(type, '', {'type': type})
      if (type === 'my_booking') {
        this.$router.push({name: 'MyTrip'})
      } else if (type === 'my_account') {
        this.$router.push({name: 'myAccount'})
      } else if (type === 'my_collection') {
        this.$router.push({name: 'myCollection'})
      } else if (type === 'my_coupon') {
        this.$router.push({name: 'myCoupon'})
      }
    },
    skipOaLink: function () {
      var hotelid = this.$route.query.hotelid
      var checkin = this.$route.query.start_date
      var checkout = this.$route.query.end_date
      var room = this.$route.query.room
      var adult = this.$route.query.adult
      var child = this.$route.query.child
      var source = this.source
      var online = 1
      // 规则
      if (hotelid === '' || hotelid === null || hotelid === undefined) {
        alert('目前仅支持在详情页点击')
        return false
      }
      if (checkin === '' || checkin === null || checkin === undefined) {
        alert('无入住日期')
        return false
      }
      if (checkout === '' || checkout === null || checkout === undefined) {
        alert('无离店日期')
        return false
      }
      if (room === '' || room === null || room === undefined) {
        alert('无房间数')
        return false
      }
      if (adult === '' || adult === null || adult === undefined) {
        alert('无成人数')
        return false
      }
      if (child === '' || child === null || child === undefined) {
        alert('无儿童数')
        return false
      }
      // 埋点
      var data = {
        'type': 'skipOaLink',
        'hotelid': hotelid,
        'checkin': checkin,
        'checkout': checkout,
        'room': room,
        'adult': adult,
        'child': child,
        'source': source
      }
      // 点击埋点 埋点记录
      this.clickPageAction('skipOaLink', '', data)
      var lfhotelid = parseInt(hotelid) - 13
      window.open('https://admin.hotel.51smart.com/admin/price/?mod=hotelSearchNew&do=list&searchType=1&act=search&type=&enablecache=0&agentname=None&platform=' + source + '&hotelname=&lfhotelid=' + lfhotelid + '&checkin=' + checkin + '&checkout=' + checkout + '&roomcount=' + room + '&adults=' + adult + '&children=' + child + '&childrenAge=0&order_id=&tpl=2&online=' + online)
    }
  }
}
</script>
<style scoped>
/deep/ .el-menu{ border: none;}
</style>



// WEBPACK FOOTER //
// src/components/public/publicMenu.vue